import { Controller } from "@hotwired/stimulus"

// A simple controller that just handles model selection
export default class extends Controller {
  static targets = ["provider", "model"]

  connect() {
    console.log("Model updater controller connected!")
  }

  updateModels() {
    console.log("updateModels called")
    
    // Get the selected provider
    const provider = this.providerTarget.value
    console.log("Selected provider:", provider)
    
    // Get the model dropdown
    const modelDropdown = this.modelTarget
    
    // Make an AJAX request to get models for this provider
    fetch(`/dashboard/ai_materials/new?provider=${provider}`, {
      headers: { "Accept": "application/json" }
    })
    .then(response => response.json())
    .then(data => {
      console.log("Received data:", data)
      
      // Clear existing options
      modelDropdown.innerHTML = ""
      
      // Add new options
      if (Array.isArray(data.models)) {
        data.models.forEach(model => {
          const option = document.createElement("option")
          option.value = model.id
          option.textContent = model.name
          
          // Select the default model
          if (model.id === data.default_model) {
            option.selected = true
          }
          
          modelDropdown.appendChild(option)
        })
      }
    })
    .catch(error => {
      console.error("Error fetching models:", error)
    })
  }
}